import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const KEY = "lotus_cookie_consent";

export default function CookieBanner() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      // Show after a small delay so it doesn't flash before page loads
      const id = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(id);
    }
  }, []);

  const handle = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 pointer-events-none"
      data-testid="cookie-banner"
    >
      <div className="container-x">
        <div className="pointer-events-auto mx-auto max-w-3xl bg-[var(--cream-soft)] border border-[var(--gold)]/30 shadow-[0_20px_50px_-20px_rgba(30,27,22,0.4)] rounded-2xl p-5 md:p-6 flex flex-col md:flex-row items-start md:items-center gap-4">
          <div className="flex-1 text-[14px] leading-relaxed text-[var(--ink)]">
            <div className="font-serif text-lg mb-1">{t.cookies.title}</div>
            <p className="text-[var(--ink-soft)]">
              {t.cookies.text}{" "}
              <Link to="/datenschutz" className="underline text-[var(--gold-dark)] hover:text-[var(--gold)]">
                {t.cookies.linkText}
              </Link>
              .
            </p>
          </div>
          <div className="flex gap-2 items-center shrink-0 w-full md:w-auto">
            <button
              onClick={() => handle("declined")}
              className="px-4 py-2 rounded-full border border-[var(--line)] text-sm hover:bg-[var(--ink)] hover:text-white hover:border-[var(--ink)] transition-all"
              data-testid="cookie-decline"
            >
              {t.cookies.decline}
            </button>
            <button
              onClick={() => handle("accepted")}
              className="px-5 py-2 rounded-full bg-[var(--gold)] text-white text-sm font-medium hover:bg-[var(--gold-dark)] transition-all flex-1 md:flex-none"
              data-testid="cookie-accept"
            >
              {t.cookies.accept}
            </button>
            <button
              onClick={() => handle("dismissed")}
              aria-label="Close"
              className="ml-1 w-8 h-8 rounded-full flex items-center justify-center text-[var(--ink-soft)] hover:bg-[var(--line)]"
              data-testid="cookie-close"
            >
              <X size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
